import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PostalService {

  url = '/service/postal'
  constructor(private http: HttpClient) { }

  getPostalData(postal: string,number : string, addition : string) : Observable<any>
  {
    var postFix = '?p='+encodeURIComponent(postal)+'&n='+encodeURIComponent(number)+'&a=' + encodeURIComponent(addition);
    return this.http.get<any>(this.url + postFix).pipe(
      tap(x => console.log(JSON.stringify( x))),
      catchError(this.handleError)
    );
  }

  private handleError(err : HttpErrorResponse){
    console.log(err);
    return throwError(()=>'');
  }
}
